import React from 'react';
import { Switch, Route } from 'react-router-dom';


const Dashboard = React.lazy(() => import('routes/Dashboard'));
const Transactions = React.lazy(() => import('routes/Transactions'));
const StaticDashboard = React.lazy(() => import('routes/StaticDashboard'));
const Explorer = React.lazy(() => import('routes/Explorer'));

const RefData = React.lazy(() => import('routes/RefData'));
const StimulationRoutes = React.lazy(() => import('routes/SimulationRoutes'));

const EntitlementRoutes = React.lazy(() => import('routes/Entitlement'));
const EventMonitoringDashboard = React.lazy(() => import(  'screens/Explorer/EventMonitoringExplorer/default'));
const ProtectedRoutes = () => {
    return (
        <Switch>
            <Route path="/dashboard" component={Dashboard}/>
            <Route path="/event-monitoring-explorer" component={EventMonitoringDashboard}/>
            <Route path="/transactions" component={Transactions}/>
            <Route path="/static" component={StaticDashboard}/>
            <Route path="/explorer" component={Explorer}/>
            <Route path={'/reference-data'} component={RefData}/>
            <Route path={'/simulation'} component={StimulationRoutes}/>
            <Route path={'/entitlement'} component={EntitlementRoutes} />
        </Switch>
    );
};

export default ProtectedRoutes;